<button [style.backgroundColor]="backgroundColor" [style.color]="color">
  <ng-content></ng-content>
</button>
